import Route from '@core/components/Route';
import { SectionDark3 } from '@homepage/components/ColoredSection';
import Grid from '@shared/components/Grid';
import { H2 } from '@shared/components/Heading';
import Paragraph from '@shared/components/Paragraph';
import { FC, memo } from 'react';

import { COMPANY } from '../../assets/company';
import { Location, TRAINING_LOCATIONS } from '../../assets/locations';

const Schedules: FC = () => (
  <SectionDark3>
    <H2>Zeiten und Orte</H2>
    <Paragraph margin={{ bottom: { md: '2.25rem', xs: '1.25rem' } }}>
      Da unsere Lehrer auch anderen beruflichen Tätigkeiten nachgehen, kann es gelegentlich zu
      leichten Verzögerungen beim Trainingsbeginn kommen. Dennoch: Die Qualität und Intensität des
      Trainings bleiben stets auf höchstem Niveau.
    </Paragraph>

    <Grid columns={{ md: 2, xs: 1 }} spacing='2rem' sx={{ marginBottom: '2rem' }}>
      {COMPANY.schedule.map(({ location, time }) => (
        <Grid.Item key={time}>
          <Paragraph bold margin='0'>
            {time}
          </Paragraph>
          <Route href={TRAINING_LOCATIONS[location as Location].url}>
            {TRAINING_LOCATIONS[location as Location].text}
          </Route>
        </Grid.Item>
      ))}
    </Grid>

    {Array.from(
      new Set(
        COMPANY.schedule.map(({ location }) => TRAINING_LOCATIONS[location as Location].footnote)
      )
    )
      .filter(footnote => footnote) // Filter out null/undefined footnotes
      .map(footnote => (
        <Paragraph key={footnote} margin='0' variant='body2'>
          {footnote}
        </Paragraph>
      ))}
  </SectionDark3>
);

export default memo(Schedules);
